var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center",staticStyle:{"padding":"0.729167rem 0 0 2.083333rem"}},[_c('div',{staticClass:"cicon"}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm._f("DateFormat")(_vm.date,"hh:mm")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }